// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-bottom-bar__handle{position:absolute;top:10px;left:calc(50% - 24px);height:2px;width:48px;border-radius:1px;background:var(--gray)}.base-bottom-bar .rz-bottom-bar__overlay{height:100dvh}.base-bottom-bar .rz-bottom-bar__head{padding:36px 22px 20px 22px}.base-bottom-bar .rz-bottom-bar__body{max-height:calc(85dvh - 106px);padding:5px 16px 20px 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
